/**
 * Shared report header field + shell configuration for HTML and PDF exports.
 */

export const REPORT_HEADER_SHELL = Object.freeze({
  estimate: {
    docTitle: "Estimate Report",
    panelTitle: "Estimate Information",
  },
  invoice: {
    docTitle: "Invoice",
    panelTitle: "Invoice Information",
  },
  payroll: {
    docTitle: "Payroll Report",
    panelTitle: "Employee Information",
  },
});

export function filterVisibleHeaderFields(fields) {
  return (fields || []).filter((field) => field.show && field.value);
}
